<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="直播编号：">
            <el-input v-model="query.liveCode" placeholder="请输入直播编号" clearable size="small" />
          </el-form-item>
          <el-form-item label="直播主题：">
            <el-input v-model="query.title" placeholder="请输入直播主题" clearable size="small" />
          </el-form-item>
          <el-form-item label="主播手机号：">
            <el-input v-model="query.anchorPhone" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="主播身份：">
            <el-select v-model="query.identity" placeholder="全部" clearable size="small">
              <el-option label="总监" value="总监"></el-option>
              <el-option label="营销经理" value="营销经理"></el-option>
              <el-option label="大区经理" value="大区经理"></el-option>
              <el-option label="地区经理" value="地区经理"></el-option>
              <el-option label="县区经理" value="县区经理"></el-option>
              <el-option label="研修班" value="研修班"></el-option>
              <el-option label="体验班" value="体验班"></el-option>
              <el-option label="普通人员" value="普通人员"></el-option>
              <el-option label="技术总监" value="技术总监"></el-option>
              <el-option label="督导" value="督导"></el-option>
              <el-option label="技术老师" value="技术老师"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="直播类型：">
            <el-select v-model="query.liveType" placeholder="请选择" clearable size="small">
              <el-option label="带货竖屏直播" :value="1"></el-option>
              <el-option label="培训横屏直播" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否app展示回放：">
            <el-select v-model="query.isViewApp" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="已展示" :value="1"></el-option>
              <el-option label="未展示" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="直播间" prop="livePO.id" align="center" fixed="left">
          <template slot-scope="{row}">
            <el-link type="primary" :underline="false" @click="handleLiveView(row.livePO.id)">
              {{ row.livePO.id }}-{{ row.livePO.title }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="主播姓名" prop="userPO.realName" align="center" fixed="left" />
        <el-table-column label="主播身份" prop="liveAnchorPO.position" align="center" />
        <el-table-column label="主播手机号" prop="userPO.userPho" align="center" min-width="130" />
        <el-table-column label="直播类型" prop="liveType" align="center">
          <template slot-scope="{row}">
            {{ row.livePO.liveType === 1 ? '带货竖屏直播' : row.livePO.liveType === 2 ? '培训横屏直播' : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="直播图片" prop="liveTitle" align="center" >
          <template slot-scope="{row}">
            <el-image :src="row.livePO.liveImg" style="width: 50px; height: 50px;" :preview-src-list="[row.livePO.liveImg]" />
          </template>
        </el-table-column>
        <!-- <el-table-column label="保留时间" prop="replayState" align="center">
          <template slot-scope="{row}">
            <div class="replay-status"> -->
              <!-- 长期回放 -->
              <!-- <el-tag v-if="row.replayState === 3 || row.replayState === '3'" type="success">长期回放</el-tag> -->
              
              <!-- 已过期 -->
              <!-- <el-tag v-else-if="row.replayState === 2 || row.replayState === '2'" type="danger">已过期</el-tag> -->
              
              <!-- 7天倒计时 (replayState === 1 或 null 或 undefined) -->
              <!-- <template v-else-if="row.replayState === 1 || row.replayState === '1' || row.replayState === null || row.replayState === undefined || row.replayState === ''">
                <el-tag v-if="getRemainingDays(row) > 7" type="danger">已过期</el-tag>
                <el-tag v-else-if="getRemainingDays(row) <= 7 && getRemainingDays(row) >= 0" type="warning">
                  {{ 7 - getRemainingDays(row) }}天后过期
                </el-tag>
                <el-tag v-else type="info">计算中...</el-tag>
              </template> -->
              
              <!-- 其他状态 -->
              <!-- <el-tag v-else type="info">未知状态({{ row.replayState }})</el-tag> -->
            <!-- </div>
          </template>
        </el-table-column> -->
        <el-table-column label="创建时间" prop="livePO.createdTime" align="center" min-width="180" />
        <el-table-column label="直播时间" prop="livePO.startTime" align="center" min-width="180" />
        <el-table-column label="结束时间" prop="livePO.endTime" align="center" min-width="180" />
        <el-table-column label="是否app展示回放" prop="isViewApp" align="center">
          <template slot-scope="{row}">
            {{ row.livePO.isViewApp === 1 ? '已展示' : '未展示' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="220" fixed="right">
          <!-- 操作按钮按原型调整 -->
          <template slot-scope="{row}">
            <!-- <el-button type="text" @click="handlePlay(row)">播放回放</el-button> -->
            <el-button type="text" @click="handleDownload(row)" v-if="row.livePO.videoUrl">播放回放</el-button>
            <!-- <el-button type="text" @click="handleLiveStatistics(row)" v-if="row.livePO && row.livePO.id">直播收益</el-button> -->
            <el-button type="text" @click="handleToggleViewApp(row)">{{ row.livePO.isViewApp===1?"APP隐藏":"APP展示" }}</el-button>
            <!-- <el-button type="text">长期保留</el-button> -->
            <!-- <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import liveManageApi from '@/api/live/liveManage'
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    /**
     * 跳转到直播间观看页面
     * @param {string} liveId - 直播ID
     */
    handleLiveView(liveId) {
      this.$router.push({
        path: '/live/liveView',
        query: { liveId: liveId }
      })
    },
    /**
     * 跳转到直播收益统计页面
     * @param {Object} row - 行数据
     */
    handleLiveStatistics(row) {
      if (!row.livePO || !row.livePO.id) {
        this.$message.error('该直播没有ID')
        return
      }
      this.$router.push({
        path: '/live/liveStatistics',
        query: { liveId: row.livePO.id }
      })
    },
    /**
     * 计算剩余天数
     * @param {Object} row - 行数据
     * @returns {number} 剩余天数
     */
    getRemainingDays(row) {
      console.log("计算剩余天数 - 完整数据:", row);
      console.log("replayState:", row.replayState, "类型:", typeof row.replayState);
      console.log("endTime:", row.livePO ? row.livePO.endTime : '无endTime');
      
      if (!row.livePO || !row.livePO.endTime) {
        console.log("缺少必要数据，返回0");
        return 0
      }
      
      const endTime = new Date(row.livePO.endTime)
      const currentTime = new Date()
      
      console.log("结束时间:", endTime);
      console.log("当前时间:", currentTime);
      console.log("结束时间字符串:", row.livePO.endTime);
      
      // 计算时间差（毫秒）：当前时间 - 结束时间
      const timeDiff = currentTime.getTime() - endTime.getTime()
      
      // 转换为天数，使用 Math.floor 向下取整
      const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
      
      console.log("时间差(毫秒):", timeDiff);
      console.log("当前时间-结束时间的天数:", daysDiff);
      
      return daysDiff
    },
    
    copyStreamUrl(url) {
      this.$copyText(url).then(() => {
        this.$message.success('复制成功')
      })
    },
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      //this.query.replayState = 1
      this.query.state = 3
      this.listLoading = true
      return liveManageApi.fetchListLive(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 播放直播回放
     * @param {Object} row - 行数据
     */
    handlePlay(row) {
      if (!row.livePO || !row.livePO.videoUrl) {
        this.$message.error('该直播没有回放地址')
        return
      }
      
      const videoUrl = row.livePO.videoUrl
      const liveId = row.livePO.id || '未知'
      
      // 如果是 m3u8 格式，在新窗口打开播放
      if (videoUrl.includes('.m3u8')) {
        // 使用浏览器原生播放器在新窗口播放
        const playWindow = window.open('', '_blank', 'width=1200,height=800')
        if (playWindow) {
          // 构建 HTML 内容，使用数组 join 避免 script 标签解析问题
          // 将 videoUrl 转义，避免引号冲突
          const escapedVideoUrl = videoUrl.replace(/"/g, '&quot;').replace(/'/g, '&#39;')
          const sourceTag = '<source src="' + escapedVideoUrl + '" type="application/x-mpegURL" crossorigin="anonymous">'
          
          const htmlParts = [
            '<!DOCTYPE html>',
            '<html>',
            '<head>',
            '<meta charset="UTF-8">',
            '<title>直播回放播放 - 直播间ID: ' + liveId + '</title>',
            '<style>',
            'body { margin: 0; padding: 0; background: #000; display: flex; flex-direction: column; }',
            '.live-id-info { padding: 10px; background: rgba(0,0,0,0.8); color: #fff; text-align: center; font-size: 14px; }',
            '.video-container { flex: 1; display: flex; align-items: center; justify-content: center; }',
            'video { width: 100%; height: calc(100vh - 40px); max-width: 100%; }',
            '.error-message { color: #f56c6c; padding: 20px; text-align: center; }',
            '</style>',
            '</head>',
            '<body>',
            '<div class="live-id-info">直播间ID: ' + liveId + '</div>',
            '<div class="video-container">',
            '<video controls autoplay crossorigin="anonymous" preload="auto">',
            sourceTag,
            '您的浏览器不支持视频播放',
            '</video>',
            '</div>',
            '<script>',
            '(function() {',
            '  var video = document.querySelector(\'video\');',
            '  if (video) {',
            '    video.addEventListener(\'error\', function(e) {',
            '      var errorMsg = document.createElement(\'div\');',
            '      errorMsg.className = \'error-message\';',
            '      var errorCode = video.error ? video.error.code : \'未知\';',
            '      errorMsg.innerHTML = \'视频加载失败，可能是跨域或网络问题。错误代码: \' + errorCode;',
            '      var container = document.querySelector(\'.video-container\');',
            '      if (container) {',
            '        container.appendChild(errorMsg);',
            '      }',
            '      console.error(\'Video error:\', video.error);',
            '    });',
            '    video.addEventListener(\'loadstart\', function() {',
            '      console.log(\'视频开始加载\');',
            '    });',
            '    video.addEventListener(\'canplay\', function() {',
            '      console.log(\'视频可以播放\');',
            '    });',
            '  }',
            '})();',
            '</' + 'script>',
            '</body>',
            '</html>'
          ]
          
          playWindow.document.write(htmlParts.join(''))
          playWindow.document.close()
        } else {
          this.$message.error('无法打开播放窗口，请检查浏览器弹窗设置')
        }
      } else {
        // 其他格式，使用弹窗显示视频和直播间ID
        const playWindow = window.open('', '_blank', 'width=1200,height=800')
        if (playWindow) {
          const escapedVideoUrl = videoUrl.replace(/"/g, '&quot;').replace(/'/g, '&#39;')
          const htmlParts = [
            '<!DOCTYPE html>',
            '<html>',
            '<head>',
            '<meta charset="UTF-8">',
            '<title>直播回放播放 - 直播间ID: ' + liveId + '</title>',
            '<style>',
            'body { margin: 0; padding: 0; background: #000; display: flex; flex-direction: column; }',
            '.live-id-info { padding: 10px; background: rgba(0,0,0,0.8); color: #fff; text-align: center; font-size: 14px; }',
            '.video-container { flex: 1; display: flex; align-items: center; justify-content: center; }',
            'video { width: 100%; height: calc(100vh - 40px); max-width: 100%; }',
            '.error-message { color: #f56c6c; padding: 20px; text-align: center; }',
            '</style>',
            '</head>',
            '<body>',
            '<div class="live-id-info">直播间ID: ' + liveId + '</div>',
            '<div class="video-container">',
            '<video controls autoplay crossorigin="anonymous" preload="auto">',
            '<source src="' + escapedVideoUrl + '" type="video/mp4">',
            '您的浏览器不支持视频播放',
            '</video>',
            '</div>',
            '<script>',
            '(function() {',
            '  var video = document.querySelector(\'video\');',
            '  if (video) {',
            '    video.addEventListener(\'error\', function(e) {',
            '      var errorMsg = document.createElement(\'div\');',
            '      errorMsg.className = \'error-message\';',
            '      var errorCode = video.error ? video.error.code : \'未知\';',
            '      errorMsg.innerHTML = \'视频加载失败，可能是跨域或网络问题。错误代码: \' + errorCode;',
            '      var container = document.querySelector(\'.video-container\');',
            '      if (container) {',
            '        container.appendChild(errorMsg);',
            '      }',
            '      console.error(\'Video error:\', video.error);',
            '    });',
            '  }',
            '})();',
            '</' + 'script>',
            '</body>',
            '</html>'
          ]
          
          playWindow.document.write(htmlParts.join(''))
          playWindow.document.close()
        } else {
          this.$message.error('无法打开播放窗口，请检查浏览器弹窗设置')
        }
      }
    },
    /**
     * 下载直播回放
     * @param {Object} row - 行数据
     */
    handleDownload(row) {
      if (!row.livePO || !row.livePO.videoUrl) {
        this.$message.error('该直播没有回放地址')
        return
      }
      
      const videoUrl = row.livePO.videoUrl
      
      // 如果是 m3u8 格式，提示用户这是流媒体格式，无法直接下载
      if (videoUrl.includes('.m3u8')) {
        this.$message.warning('该回放为 HLS 流媒体格式(.m3u8)，无法直接下载。请使用"播放回放"功能观看，或使用专业工具下载。')
        // 可选：在新窗口打开播放链接
        this.handlePlay(row)
        return
      }
      
      // 其他格式（如 mp4）可以尝试下载
      // 生成文件名：优先使用直播名称，否则使用直播ID，最后使用时间戳
      let fileName = '直播回放'
      if (row.livePO && row.livePO.liveName) {
        fileName = '直播回放_' + row.livePO.liveName
      } else if (row.livePO && row.livePO.id) {
        fileName = '直播回放_' + row.livePO.id
      } else {
        fileName = '直播回放_' + Date.now()
      }
      
      // 清理文件名中的特殊字符，避免下载时出错
      fileName = fileName.replace(/[<>:"/\\|?*]/g, '_')
      
      // 创建下载链接并触发下载
      const link = document.createElement('a')
      link.href = videoUrl
      link.download = fileName + '.mp4'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      
      this.$message.success('开始下载直播回放')
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => liveManageApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => liveManageApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 0)
      }
    },
    handleBatchState(ids, type) {
      let txt = type === 1 ? '确认将选中批量启用？' : '确认将选中批量禁用？'
      this.$common.confirm(txt).then(() => liveManageApi.setIsEnableBatch({ ids: ids, isEnable: type ? true : false }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      liveManageApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.liveAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.liveAdd.handleUpdate(row)
    },
    /**
     * 切换APP显示状态
     * @param {Object} row - 行数据
     */
    handleToggleViewApp(row) {
      if (!row.livePO || !row.livePO.id) {
        this.$message.error('该直播没有ID')
        return
      }
      
      // 当前状态：1表示已展示，0表示未展示
      // 点击后切换状态：如果当前是1，则变为0；如果当前是0，则变为1
      const currentStatus = row.livePO.isViewApp === 1 ? 1 : 0
      const newStatus = currentStatus === 1 ? 0 : 1
      const actionText = newStatus === 1 ? 'APP展示' : 'APP隐藏'
      
      this.$common.confirm(`确认${actionText}该直播回放？`)
        .then(() => {
          return liveManageApi.setLiveIsViewApp({
            liveId: row.livePO.id,
            isViewApp: newStatus
          })
        })
        .then(() => {
          this.$common.showMsg('success', `${actionText}成功`)
          // 更新本地数据状态
          row.isViewApp = newStatus
          // 刷新列表
          return this.doQueryList({})
        })
        .catch(() => {
          // 用户取消或请求失败，不显示错误（避免重复提示）
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.replay-status {
  display: flex;
  justify-content: center;
  align-items: center;
  
  .el-tag {
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 4px;
  }
}
</style>

